import { EDITOR_DEFAULT_MESH_TRANSPARENCY } from '@editor/config/styles'
import {
  deleteStateFromLocalStorage,
  loadStateFromLocalStorage,
  saveStateToLocalStorage,
} from '@editor/services/localStorage'
import { MeshState } from '@infraloop/common'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface SolidMeshState {
  /**
   * Stage of solid mesh loading.
   */
  state: MeshState

  /**
   * Progress of solid mesh loading (0 to 1).
   */
  progress?: number

  /**
   * Flag to indicate if the solid mesh file is visible.
   */
  isVisible: boolean

  /**
   * Flag to indicate if the solid mesh is present.
   */
  isPresent: boolean

  /**
   * Transparency of the solid mesh (0 to 1).
   */
  transparency: number
}

const initialState: SolidMeshState = {
  state: MeshState.None,
  progress: undefined,
  isVisible: true,
  isPresent: false,
  transparency: loadStateFromLocalStorage('solidMeshTransparency', EDITOR_DEFAULT_MESH_TRANSPARENCY),
}

const solidMeshSlice = createSlice({
  name: 'projects/common/solidMesh',
  initialState,
  reducers: {
    setSolidMeshStage: (state, action: PayloadAction<MeshState>) => {
      state.state = action.payload
    },
    setProgress: (state, { payload }: PayloadAction<number | undefined>) => {
      state.progress = payload
    },
    setIsPresent: (state, action: PayloadAction<boolean>) => {
      state.isPresent = action.payload
    },
    setIsVisible: (state, action: PayloadAction<boolean>) => {
      state.isVisible = action.payload
    },
    setTransparency: (state, { payload }: PayloadAction<number>) => {
      state.transparency = payload
      saveStateToLocalStorage('solidMeshTransparency', payload)
    },
    resetTransparency: (state) => {
      state.transparency = initialState.transparency
      deleteStateFromLocalStorage('solidMeshTransparency')
    },
  },
})

export const {
  // Solid mesh
  setSolidMeshStage,
  setProgress,
  setIsPresent,
  setIsVisible,
  setTransparency,
  resetTransparency,
} = solidMeshSlice.actions

export default solidMeshSlice.reducer
